import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SoccerBall } from "@phosphor-icons/react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]">
        <SoccerBall size={48} className="text-[#CCFF00] animate-spin" weight="fill" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return children;
}
